module.exports = __webpack_public_path__ + "static/logo-14cf8aad8b2bb0ff7093a55404d1ba0c.png";